<template>
  <span v-if="navPermissions['portalAdmin'].enable">
        <a
            :aria-expanded="adminCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="(adminCollaps=!adminCollaps)">
            <template>
                <i class="fa pr-2 fa-lock text-info"></i>
                <span class="nav-link-text">Administration <b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="adminCollaps" id="collapse-just" :class="adminCollaps?'show':''" class="collapse">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/data_management"
                            to="/data_management"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-database text-success pr-2"></i>
                                <span class="nav-link-text">Data Management</span>
                            </template>
                        </router-link>
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/data_management"
                            to="/inventory_management"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-table text-indigo pr-2"></i>
                                <span class="nav-link-text">Inventory Management</span>
                            </template>
                        </router-link>
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/tower_management"
                            to="/tower_management"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-podcast text-yellow pr-2"></i>
                                <span class="nav-link-text">Tower Management</span>
                            </template>
                        </router-link>
                        <router-link
                            :target="link.target"
                            class="nav-link"
                            href="/admin/user_admin"
                            to="/admin/user_admin"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-user text-danger pr-2"></i>
                                <span class="nav-link-text">User Management</span>
                            </template>
                        </router-link>
                    </slot>
                </ul>
            </div>
        </collapse-transition>
    </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "@/common/api-services/init-service";

export default {
  name: 'side-admin-custom-group',
  components: {
    CollapseTransition
  },

  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],

      adminCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },

      navPermissions: {
        "portalAdmin": {
          enable: false,
          role: ["Administrator"],
          data: {
            "adminAccess": {
              enable: false,
              role: ["PORTAL_ADMIN", "Administrator"]
            },
          }
        }
      }
    }
  },

  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  },

  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>